export default function initAccordions(){
    var faqCheckboxes = document.querySelectorAll(".faq-checkbox")
    for (let i = 0; i < faqCheckboxes.length; ++i) {
        faqCheckboxes[i].addEventListener('change', e => {
            var contentContainer = faqCheckboxes[i].parentElement.querySelectorAll(".tab-content")[0];
            if (e.target.checked) {
                slideDown(contentContainer);
            } else {
                slideUp(contentContainer);
            }
        });
    }

    const slideDown = element => {
      element.style.height = `${element.scrollHeight}px`;
      element.parentElement.classList.add("opened");
    };

    const slideUp = element => {
      element.style.height = 0;
      element.parentElement.classList.remove("opened");
    };
};
